import Vue from 'vue';

const defaultState = {
  assetViews: {},
};

const assetViewGetters = {
  get: (state) => state.assetViews,
};

const mutations = {
  set: (state, payload) => {
    const key = `${payload.assetType}-${payload.assetId}`;
    Vue.set(state.assetViews, key, payload.totalViews);
  },
};

const actions = {
  fetch({dispatch, commit, getters, rootGetters}, params) {
    return rootGetters['session/ajax'].get('/asset_views', { params }).then(({ data }) => {
      commit('set', data);
      return data;
    });
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters: assetViewGetters,
  mutations,
  actions,
};
